const FADE_INTERVAL = 5000;

class CedarwoodFadeSlides extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.c_js-fade-slide'));
    if (this.slides.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.index = 0;
    this.timer = window.setInterval(this.next.bind(this), FADE_INTERVAL);

    // タブが裏に回っている間は切り替えても見えないため止める
    this.onVisibility = this.onVisibility.bind(this);
    document.addEventListener('visibilitychange', this.onVisibility);
  }

  disconnectedCallback() {
    this.stop();
    document.removeEventListener('visibilitychange', this.onVisibility);
  }

  onVisibility() {
    if (document.hidden) {
      this.stop();
    } else if (!this.timer) {
      this.timer = window.setInterval(this.next.bind(this), FADE_INTERVAL);
    }
  }

  stop() {
    if (!this.timer) return;
    window.clearInterval(this.timer);
    this.timer = null;
  }

  next() {
    this.slides[this.index].classList.remove('is-active');
    this.index = (this.index + 1) % this.slides.length;
    this.slides[this.index].classList.add('is-active');
  }
}

if (!customElements.get('cedarwood-fade-slides')) {
  customElements.define('cedarwood-fade-slides', CedarwoodFadeSlides);
}
